import { AEMErrorMessage } from '../../../models';

export const TrackerErrorMessage: AEMErrorMessage = {
  action: {
    label: 'Learn How To Qualify For Status',
    url: '/us/en/skymiles/medallion-program/how-to-qualify',
    id: 'learnQualifyStatusTracker'
  },
  component: 'tracker',
  errorId: [
    {
      errorCode: 'CRD_5002'
    },
    {
      errorCode: 'CRD_2000'
    },
    {
      errorCode: 'CRD_1000'
    },
    {
      errorCode: 'CRD_2006'
    },
    {
      errorCode: 'CRD_5000'
    },
    {
      errorCode: 'CRD_4000'
    },
    {
      errorCode: '702'
    }
  ],
  featureTitle: '',
  errorMessageDescription:
    'Sorry, we’re currently unable to display your SkyMiles Tracker. Please try again later.',
  errorMessageTitle: '',
  type: 'single-error'
};
